import React, { useRef, useState } from 'react';
import { Box } from '@mui/material';
import SpecialPriceHeaderHeader
  from '@/pages/specialPriceTable/specialPriceApproval/components/specialPriceApprovalHeader/specialPriceApprovalHeader';
import SpecialPriceApprovalTable
  from '@/pages/specialPriceTable/specialPriceApproval/components/specialPriceApprovalTable/specialPriceApprovalTable';
import {
  BaseSpecialPrickIdGetCustomerApi,
  BaseSpecialPrickIdGetMaterialApi, ExportSaleTableSalesApplicationStatus,
  SearchSpecialPrickHeaderTableApi,
  SpecialPriceApprovalApi,
} from '@/services/api/specialPriceTable';
import {
  SpecialPriceApprovalTableRef,
} from '@/pages/specialPriceTable/specialPriceApproval/components/specialPriceApprovalTable/type';

import { NoticeRef } from '@/components/notice/types';
import {
  SearchSpecialPrickHeaderTableRequest,
} from '@/services/api/specialPriceTable/message/SearchSpecialPrickHeaderTableRequest';
import Notice from '@/components/notice';
import { BaseOverflow } from '@/styles';
import {
  ExportSaleTableSalesApplicationStatusRequest,
} from '@/services/api/specialPriceTable/message/ExportSaleTableSalesApplicationStatusRequest';

const SpecialPriceApproval = () => {
  const specialPriceApprovalTableRef = useRef<SpecialPriceApprovalTableRef>(null);

  const [headerTotal, setHeaderTotal] = useState<number>(0);

  const noticeRef = useRef<NoticeRef>(null);

  const [headerModel, setHeaderModel] = useState<SearchSpecialPrickHeaderTableRequest>({
    CreateDateEnd: null,
    CreateDateStart: null,
    SalesNameLike: '',
    Type: null,
    Page: {
      Limit: 10,
      Page: 0,
    },
  });

  const [specialPrickIdUseState, setSpecialPrickIdUseState] = useState('');

  const load = (inModel: SearchSpecialPrickHeaderTableRequest) => {
    setHeaderModel({ ...inModel });
    SearchSpecialPrickHeaderTableApi(inModel)
      .then((data) => {
        setHeaderTotal(data.Data.Total);
        if (data.Data.List.length > 0) {
          specialPriceApprovalTableRef.current?.LoadHeader(data.Data.List);
          specialPriceApprovalTableRef.current?.LoadItem([], []);
          setHeaderTotal(data.Data.Total);
        } else {
          specialPriceApprovalTableRef.current?.LoadHeader([]);
          specialPriceApprovalTableRef.current?.LoadItem([], []);
          noticeRef.current?.Show({ Open: true, Message: data.Msg, TypeInfo: 'error' });
        }
      });
  };

  const headerClick = (specialPrickId:string) => {
    setSpecialPrickIdUseState(specialPrickId);
    BaseSpecialPrickIdGetCustomerApi({ SpecialPrickId: specialPrickId })
      .then((data) => {
        BaseSpecialPrickIdGetMaterialApi({ SpecialPrickId: specialPrickId })
          .then((data2) => {
            specialPriceApprovalTableRef.current?.LoadItem(data.Data, data2.Data);
          });
      });
  };

  return (
        <Box sx={{ ...BaseOverflow }}>
            <Notice ref={noticeRef}/>
            <SpecialPriceHeaderHeader
                SpecialPriceApprovalLoad={
                    (viewModel) => {
                      load(viewModel);
                    }}
                OutPdfExcelClick={(viewModel) => {
                  ExportSaleTableSalesApplicationStatus(viewModel);
                }}
            />
            <SpecialPriceApprovalTable
                ref={specialPriceApprovalTableRef}
                ApprovalButton={(inModel) => {
                  if (inModel.SpecialPrickMaterialInformationIdList.length === 0) {
                    noticeRef.current?.Show({
                      Open: true,
                      Message: '没有检查到需要提交的数据',
                      TypeInfo: 'error',
                    });
                    return;
                  }

                  SpecialPriceApprovalApi({
                    ApprovalType: inModel.ApprovalType,
                    SpecialPrickMaterialInformationIdList: inModel.SpecialPrickMaterialInformationIdList,
                  }).then((data) => {
                    if (data.Data.IsSuccessful) {
                      noticeRef.current?.Show({
                        Open: true,
                        Message: data.Msg,
                        TypeInfo: 'success',
                      });
                      headerClick(specialPrickIdUseState);
                    } else {
                      noticeRef.current?.Show({
                        Open: true,
                        Message: data.Msg,
                        TypeInfo: 'error',
                      });
                    }
                  });
                }}
                HeaderClick={headerClick}
                handleChangePage={(event, newPage) => {
                  headerModel.Page.Page = newPage;
                  load({ ...headerModel });
                }}
                handleChangeRowsPerPage={(event) => {
                  headerModel.Page.Limit = parseInt(event.target.value);
                  load({ ...headerModel });
                }}
                page={headerModel.Page}
                headerTotal={headerTotal}
            />
        </Box>
  );
};

export default SpecialPriceApproval;
